import {
    Box,
    Button,
    ChakraProvider,
    Divider,
    Flex,
    Grid,
    IconButton,
    Image,
    Text,
    theme,
} from "@chakra-ui/react";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { removeCurrentItem } from "../../actions/current_item";
import { orderCalculation } from "../../actions/order_actions";
import {
    insertItem,
    updateItemQty,
    updateSelectedModifiers
} from "../../actions/order_items";
import Colors from "../../assets/colors/Colors";
import cartoutline from "../../assets/images/cartoutline.svg";
import noimage from "../../assets/images/notimage.svg";
import { GrubInput, GrubTitleText } from "../index";
import { useGrubDialog } from "./useGrubDialog";

const GrubDialog = (props) => {
    const {
        handleAddToCart,
        updateCartProduct,
        handleModifiersCloseModal,
        handleRadio,
        handleQuantityChange,
        setSelectedModifiers,
        setQuantity,
        formik,
        totalPrice,
        quantity,
        modalSizes,
        categoryName,
        selectedModifiers,
        isLoading,
    } = useGrubDialog(props);
    return (
        <Dialog
            open={props.isOpen}
            fullWidth={true}
            maxWidth={modalSizes}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Flex flexDirection="row" height="20%" justifyContent="flex-end">
                <IconButton
                    variant="posghost"
                    onClick={() => {
                        handleModifiersCloseModal();
                        setSelectedModifiers([]);
                        setQuantity(1);
                    }}
                    mt={{ base: "1.5rem", md: "1rem" }}
                    ml={{ base: "1rem", md: "0" }}
                    mr={{ base: "auto", md: "1rem" }}
                    width={"1.875rem"}
                    height={"1.875rem"}
                    bg={Colors.posTextAreaBackground}
                    borderRadius="1.5rem"
                    icon={<MdClose size="1rem" color={Colors.posTextInfo} />}
                />
            </Flex>
            <DialogContent
                sx={{
                    paddingRight: { base: "1rem", md: "2.06rem" },
                    paddingLeft: { base: "1rem", md: "2.06rem" },
                    paddingTop: "0rem",
                    paddingBottom: "1.5rem",
                    fontSize: "1.5rem",
                    fontWeight: 600,
                    color: Colors.posTextInfo,
                    height: "calc(100vh - 200px)",
                    overflow: "hidden",
                }}
            >
                <Flex
                    height="100%"
                    direction={{
                        base: "column",
                        md: "column",
                        lg: "row",
                    }}
                    gap={{ base: "1rem", md: "4rem" }}
                >
                    {props.order_items && (
                        <Flex
                            display={{
                                base: "none",
                                md: "flex",
                            }}
                            direction="column"
                            position="sticky"
                            top="0"
                            flexShrink={0}
                            height="fit-content"
                        >
                            <Box
                                height="25.63rem"
                                minW="18.06rem"
                                bg="#C3D1E61A"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                borderRadius="0.75rem"
                                position="relative"
                                overflow="hidden"
                                backgroundImage={`url(${props.current_item[0]?.image_url})`}
                                backgroundSize="cover"
                                backgroundPosition="center"
                            >
                                <Box
                                    position="absolute"
                                    top="1.19rem"
                                    right="1rem"
                                    bg="#FFECEA"
                                    borderRadius="0.63rem"
                                    px="0.75rem"
                                    py="0.3rem"
                                    boxShadow="sm"
                                    zIndex="2"
                                >
                                    <Text
                                        fontStyle="normal"
                                        fontWeight={500}
                                        fontSize="0.56rem"
                                        lineHeight={"0.70rem"}
                                        color="#3E3E3E"
                                        bg="#FFECEA"
                                    >
                                        {categoryName || "Category Name"}
                                    </Text>
                                </Box>
                                {/* <Box
                                    minW="18.06rem"
                                    display="flex"
                                    flexDirection="column"
                                    alignItems="center"
                                    justifyContent="center"
                                    overflow="hidden"
                                    bg={Colors.noProductBgColor}
                                >
                                    {props.current_item[0]?.image_url && (
                                        <Image
                                            src={
                                                props.current_item[0]?.image_url
                                            }
                                            alt="Image Not Found"
                                            objectFit="contain"
                                            display="block"
                                            onError={(e) => {
                                                e.target.src = noimage;
                                            }}
                                        />
                                    )}
                                </Box> */}
                            </Box>
                            {/* <Flex
                                mt="1.44rem"
                                gap="0.5rem"
                                justify="center"
                                direction={{
                                    base: "row",
                                    md: "row",
                                }}
                                height="4.88rem"
                                wrap={{
                                    base: "wrap",
                                    md: "nowrap",
                                }}
                            >
                                {[...Array(4)].map((_, i) => (
                                    <Image
                                        key={i}
                                        bg="#C3D1E61A"
                                        border={"0.06rem solid #D9D9D95E"}
                                        src={
                                            props.current_item[0]?.image_url ||
                                            noimage
                                        }
                                        alt="Image Coming Soon"
                                        borderRadius="md"
                                        boxSize={{
                                            base: "3rem",
                                            md: "3.62rem",
                                        }}
                                        onError={(e) => {
                                            e.target.src = noimage;
                                        }}
                                    />
                                ))}
                            </Flex> */}
                        </Flex>
                    )}
                    <Box
                        flex={{ base: "1", md: "2" }}
                        mt={{ base: "1rem", md: "0.5rem" }}
                        overflowY="auto"
                        height="100%"
                        sx={{
                            "&::-webkit-scrollbar": {
                                display: "none",
                            },
                            "&::-webkit-scrollbar-track": {
                                display: "none",
                            },
                            msOverflowStyle: "none",
                            scrollbarWidth: "none",
                        }}
                    >
                        {props.current_item && (
                            <Box>
                                <GrubTitleText
                                    isLabelText={true}
                                    color={Colors.posTextInfo}
                                    name={props.current_item[0]?.name}
                                />
                                <Box display={{ base: "block", md: "none" }}>
                                    <GrubTitleText
                                        isModifierText={true}
                                        mt={{
                                            base: "0.88rem",
                                            md: "0",
                                        }}
                                        px="0.75rem"
                                        py="0.3rem"
                                        color={Colors.posTextInfo}
                                        name={categoryName || "Category Name"}
                                    />
                                </Box>
                                <GrubTitleText
                                    isLabelText={true}
                                    color={Colors.posTextInfo}
                                    mt={"0.56rem"}
                                    display={{
                                        base: "none",
                                        md: "flex",
                                    }}
                                    name={
                                        props.current_item[0]
                                            ?.online_ordering_price
                                            ? `$${(
                                                  parseFloat(
                                                      props.current_item[0]
                                                          ?.online_ordering_price
                                                  ) -
                                                  parseFloat(
                                                      props.current_item[0]
                                                          ?.total_modifiers_price
                                                  )
                                              ).toFixed(2)}`
                                            : `$${(
                                                  parseFloat(
                                                      props.current_item[0]
                                                          ?.sale_price
                                                  ) -
                                                  parseFloat(
                                                      props.current_item[0]
                                                          ?.total_modifiers_price
                                                  )
                                              ).toFixed(2)}`
                                    }
                                />
                                {props.current_item[0]?.categories.length >
                                    0 && (
                                    <GrubTitleText
                                        isDescription={true}
                                        mt="2"
                                        color={Colors.posTextInfo}
                                        display={{
                                            base: "none",
                                            md: "flex",
                                        }}
                                        name={
                                            props.current_item[0]
                                                ?.product_description &&
                                            `${props.current_item[0]?.product_description.substring(
                                                0,
                                                65
                                            )}${
                                                props.current_item[0]
                                                    .product_description
                                                    .length > 32
                                                    ? "..."
                                                    : ""
                                            }`
                                        }
                                    />
                                )}
                                {props.order_items && (
                                    <Flex
                                        display={{
                                            base: "flex",
                                            md: "none",
                                        }}
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <Box
                                            flex={"1"}
                                            mt="0.88rem"
                                            display="flex"
                                            flexDirection="column"
                                            alignItems="center"
                                            justifyContent="center"
                                            mb={{
                                                base: "1rem",
                                                md: "0",
                                            }}
                                            height="12.44rem"
                                            minW="11.31rem"
                                            position="relative"
                                            bg={Colors.posviewbgcolor}
                                        >
                                            {props.current_item[0]
                                                ?.image_url && (
                                                <Image
                                                    src={
                                                        props.current_item[0]
                                                            ?.image_url
                                                    }
                                                    alt="Image Coming Soon"
                                                    borderRadius={{
                                                        base: "0.50rem",
                                                        md: "0rem",
                                                    }}
                                                    position="absolute"
                                                    top="0"
                                                    left="0"
                                                    width="100%"
                                                    height="100%"
                                                    objectFit="cover"
                                                    onError={(e) => {
                                                        e.target.src = noimage;
                                                    }}
                                                />
                                            )}
                                        </Box>
                                    </Flex>
                                )}
                                {props?.current_item[0]?.modifier_set?.map(
                                    (modifierSet) => (
                                        <Box key={modifierSet.id}>
                                            <ChakraProvider theme={theme}>
                                                {modifierSet.only_one ? (
                                                    <Box>
                                                        <Flex gap={"0.3rem"}>
                                                            <GrubTitleText
                                                                isInstuction={
                                                                    true
                                                                }
                                                                color={
                                                                    Colors.posTextInfo
                                                                }
                                                                mt="1.5rem"
                                                                mb="0.88rem"
                                                                name={
                                                                    modifierSet.name
                                                                }
                                                            />
                                                            <GrubTitleText
                                                                isSelected={
                                                                    true
                                                                }
                                                                color={
                                                                    Colors.posTextInfo
                                                                }
                                                                mt="1.5rem"
                                                                mb="0.88rem"
                                                                name={
                                                                    "(Select One)"
                                                                }
                                                            />
                                                        </Flex>
                                                        <RadioGroup>
                                                            <Grid
                                                                templateColumns={{
                                                                    base: "repeat(1, 1fr)",
                                                                    md: "repeat(3, 1fr)",
                                                                }}
                                                                gap={"0.56rem"}
                                                            >
                                                                {modifierSet.modifiers.map(
                                                                    (
                                                                        item,
                                                                        innerIndex
                                                                    ) => {
                                                                        return (
                                                                            <Box
                                                                                key={
                                                                                    innerIndex
                                                                                }
                                                                                onClick={() => {
                                                                                    handleRadio(
                                                                                        modifierSet,
                                                                                        item
                                                                                    );
                                                                                }}
                                                                                border={{
                                                                                    base: "none",
                                                                                    md: selectedModifiers.includes(
                                                                                        item.id
                                                                                    )
                                                                                        ? "0.06rem solid #5881FE"
                                                                                        : "0.06rem solid #E2E8F0",
                                                                                }}
                                                                                borderColor={
                                                                                    selectedModifiers.includes(
                                                                                        item.id
                                                                                    )
                                                                                        ? "#3182CE"
                                                                                        : "#E2E8F0"
                                                                                }
                                                                                borderRadius="0.5rem"
                                                                                pr={{
                                                                                    base: "none",
                                                                                    md: "0.63rem",
                                                                                }}
                                                                                pb={{
                                                                                    base: "none",
                                                                                    md: "0.38rem",
                                                                                }}
                                                                                pl={{
                                                                                    base: "0.50rem",
                                                                                    md: "0.81rem",
                                                                                }}
                                                                                pt={{
                                                                                    base: "none",
                                                                                    md: "0.5rem",
                                                                                }}
                                                                                backgroundColor={{
                                                                                    base: "",
                                                                                    md: selectedModifiers.includes(
                                                                                        item.id
                                                                                    )
                                                                                        ? "#EBF8FF"
                                                                                        : "#FFFFFF",
                                                                                }}
                                                                                sx={{
                                                                                    cursor: "pointer",
                                                                                    transition:
                                                                                        "all 0.3s",
                                                                                    "&:hover":
                                                                                        {
                                                                                            borderColor:
                                                                                                Colors.taxInfo,
                                                                                            backgroundColor:
                                                                                                "#EBF8FF",
                                                                                        },
                                                                                }}
                                                                            >
                                                                                <FormControlLabel
                                                                                    key={
                                                                                        item.id
                                                                                    }
                                                                                    value={
                                                                                        item.id
                                                                                    }
                                                                                    checked={selectedModifiers.includes(
                                                                                        item.id
                                                                                    )}
                                                                                    control={
                                                                                        <Radio />
                                                                                    }
                                                                                    label={
                                                                                        <Box
                                                                                            onClick={(
                                                                                                e
                                                                                            ) => {
                                                                                                e.stopPropagation();
                                                                                            }}
                                                                                        >
                                                                                            <GrubTitleText
                                                                                                isCategoryText={
                                                                                                    true
                                                                                                }
                                                                                                color={
                                                                                                    Colors.posTextInfo
                                                                                                }
                                                                                                name={
                                                                                                    item.name
                                                                                                }
                                                                                            />
                                                                                            <GrubTitleText
                                                                                                isInstuction={
                                                                                                    true
                                                                                                }
                                                                                                color={
                                                                                                    Colors.posTextInfo
                                                                                                }
                                                                                                name={`$${
                                                                                                    item?.price
                                                                                                        ? item.price.toFixed(
                                                                                                              2
                                                                                                          )
                                                                                                        : "0.00"
                                                                                                }`}
                                                                                            />
                                                                                        </Box>
                                                                                    }
                                                                                />
                                                                                <Box
                                                                                    sx={{
                                                                                        display:
                                                                                            "flex",
                                                                                        flexDirection:
                                                                                            {
                                                                                                base: "column",
                                                                                                sm: "column",
                                                                                                md: "row",
                                                                                                lg: "row",
                                                                                                xl: "row",
                                                                                            },
                                                                                    }}
                                                                                >
                                                                                    <Divider
                                                                                        sx={{
                                                                                            display:
                                                                                                {
                                                                                                    base: "block",
                                                                                                    sm: "block",
                                                                                                    md: "none",
                                                                                                    lg: "none",
                                                                                                    xl: "none",
                                                                                                },
                                                                                        }}
                                                                                    />
                                                                                </Box>
                                                                            </Box>
                                                                        );
                                                                    }
                                                                )}
                                                            </Grid>
                                                        </RadioGroup>
                                                    </Box>
                                                ) : (
                                                    <Box
                                                        mt={{
                                                            base: "0rem",
                                                            md: "0.6rem",
                                                        }}
                                                    >
                                                        <Flex gap={"0.3rem"}>
                                                            <GrubTitleText
                                                                isInstuction={
                                                                    true
                                                                }
                                                                mb="0.88rem"
                                                                mt="0.88rem"
                                                                color={
                                                                    Colors.posTextInfo
                                                                }
                                                                name={
                                                                    modifierSet.name
                                                                }
                                                            />
                                                            <GrubTitleText
                                                                isSelected={
                                                                    true
                                                                }
                                                                color={
                                                                    Colors.posTextInfo
                                                                }
                                                                mb="0.88rem"
                                                                mt="0.88rem"
                                                                name={
                                                                    "(Select Multiple)"
                                                                }
                                                            />
                                                        </Flex>
                                                        <Grid
                                                            templateColumns={{
                                                                base: "repeat(1, 1fr)",
                                                                md: "repeat(3, 1fr)",
                                                            }}
                                                            gap={"0.56rem"}
                                                        >
                                                            {modifierSet?.modifiers?.map(
                                                                (item) => (
                                                                    <Box
                                                                        key={
                                                                            item.id
                                                                        }
                                                                        onClick={() => {
                                                                            handleRadio(
                                                                                modifierSet,
                                                                                item
                                                                            );
                                                                        }}
                                                                        pr={{
                                                                            base: "none",
                                                                            md: "0.63rem",
                                                                        }}
                                                                        pb={{
                                                                            base: "none",
                                                                            md: "0.38rem",
                                                                        }}
                                                                        pl={{
                                                                            base: "0.50rem",
                                                                            md: "0.81rem",
                                                                        }}
                                                                        pt={{
                                                                            base: "none",
                                                                            md: "0.5rem",
                                                                        }}
                                                                        border={{
                                                                            base: "none",
                                                                            md: selectedModifiers.includes(
                                                                                item.id
                                                                            )
                                                                                ? "0.06rem solid #5881FE"
                                                                                : "0.06rem solid #E2E8F0",
                                                                        }}
                                                                        backgroundColor={
                                                                            selectedModifiers.includes(
                                                                                item.id
                                                                            )
                                                                                ? "#EBF8FF"
                                                                                : "#FFFFFF"
                                                                        }
                                                                        sx={{
                                                                            borderRadius:
                                                                                "0.44rem",
                                                                            cursor: "pointer",
                                                                            transition:
                                                                                "all 0.3s",
                                                                            "&:hover":
                                                                                {
                                                                                    borderColor:
                                                                                        Colors.taxInfo,
                                                                                    backgroundColor:
                                                                                        "#EBF8FF",
                                                                                },
                                                                        }}
                                                                    >
                                                                        <FormControlLabel
                                                                            checked={selectedModifiers.includes(
                                                                                item.id
                                                                            )}
                                                                            control={
                                                                                <Checkbox />
                                                                            }
                                                                            label={
                                                                                <Box
                                                                                    onClick={(
                                                                                        e
                                                                                    ) => {
                                                                                        e.stopPropagation();
                                                                                    }}
                                                                                >
                                                                                    <GrubTitleText
                                                                                        isCategoryText={
                                                                                            true
                                                                                        }
                                                                                        color={
                                                                                            Colors.posTextInfo
                                                                                        }
                                                                                        name={
                                                                                            item.name
                                                                                        }
                                                                                    />
                                                                                    <GrubTitleText
                                                                                        isInstuction={
                                                                                            true
                                                                                        }
                                                                                        color={
                                                                                            Colors.posTextInfo
                                                                                        }
                                                                                        name={`$${
                                                                                            item?.price
                                                                                                ? item.price.toFixed(
                                                                                                      2
                                                                                                  )
                                                                                                : "0.00"
                                                                                        }`}
                                                                                    />
                                                                                </Box>
                                                                            }
                                                                        />
                                                                        <Box
                                                                            sx={{
                                                                                display:
                                                                                    "flex",
                                                                                flexDirection:
                                                                                    {
                                                                                        base: "column",
                                                                                        sm: "column",
                                                                                        md: "row",
                                                                                        lg: "row",
                                                                                        xl: "row",
                                                                                    },
                                                                            }}
                                                                        >
                                                                            <Divider
                                                                                sx={{
                                                                                    display:
                                                                                        {
                                                                                            base: "block",
                                                                                            sm: "block",
                                                                                            md: "none",
                                                                                            lg: "none",
                                                                                            xl: "none",
                                                                                        },
                                                                                }}
                                                                            />
                                                                        </Box>
                                                                    </Box>
                                                                )
                                                            )}
                                                        </Grid>
                                                    </Box>
                                                )}
                                            </ChakraProvider>
                                        </Box>
                                    )
                                )}
                                <ChakraProvider theme={theme}>
                                    <Flex
                                        mt="1.25rem"
                                        display={{
                                            base: "none",
                                            md: "flex",
                                        }}
                                    >
                                        <Box>
                                            <GrubTitleText
                                                isInstuction={true}
                                                color={Colors.posTextInfo}
                                                name={"Quantity"}
                                            />
                                            <Flex
                                                mt="2"
                                                alignItems="center"
                                                width="fit-content"
                                                p={1}
                                                gap="1"
                                                border="0.05rem solid #E2E8F0"
                                                borderRadius="1.5rem"
                                            >
                                                <Button
                                                    border="0.05rem solid #E2E8F0"
                                                    borderRadius="0.75rem"
                                                    size="xs"
                                                    bg={
                                                        Colors.grubBackgroundColor
                                                    }
                                                    onClick={() =>
                                                        handleQuantityChange(
                                                            "decrement"
                                                        )
                                                    }
                                                    minWidth="1.5rem"
                                                    height="1.5rem"
                                                >
                                                    <Text
                                                        color={
                                                            Colors.grubHeaderColor
                                                        }
                                                        fontSize="0.88rem"
                                                    >
                                                        -
                                                    </Text>
                                                </Button>
                                                <GrubTitleText
                                                    isHeading={true}
                                                    color={Colors.posTextInfo}
                                                    name={quantity}
                                                />
                                                <Button
                                                    border="0.05rem solid #E2E8F0"
                                                    borderRadius="0.75rem"
                                                    size="xs"
                                                    bg={
                                                        Colors.grubAddBackground
                                                    }
                                                    onClick={() =>
                                                        handleQuantityChange(
                                                            "increment"
                                                        )
                                                    }
                                                    minWidth="1.5rem"
                                                    height="1.5rem"
                                                >
                                                    <Text
                                                        color={
                                                            Colors.grubBackgroundColor
                                                        }
                                                        fontSize="0.88rem"
                                                    >
                                                        +
                                                    </Text>
                                                </Button>
                                            </Flex>
                                        </Box>
                                    </Flex>
                                    <Box
                                        mt={{
                                            base: "2rem",
                                            md: "1.5rem",
                                        }}
                                        mb={{
                                            base: "1rem",
                                            md: "1rem",
                                        }}
                                    >
                                        <GrubTitleText
                                            isInstuction={true}
                                            color={Colors.posTextInfo}
                                            mb="0.56rem"
                                            name={"Special Instruction"}
                                        />
                                        <GrubInput
                                            id="instruction"
                                            placeholder={"Enter Instruction"}
                                            handleInputChange={
                                                formik.handleChange
                                            }
                                            inputValue={
                                                formik?.values?.instruction ||
                                                ""
                                            }
                                            handleBlur={(e) => {
                                                formik.setFieldValue(
                                                    "instruction",
                                                    formik.values.instruction.trim()
                                                );
                                                formik.handleBlur(e);
                                            }}
                                            variant={"posBasicInput"}
                                            height="3.44rem"
                                            posInput={true}
                                            darkPlaceholder={true}
                                            background={Colors.posviewbgcolor}
                                            inputType={"text"}
                                            inputError={
                                                formik.touched.instruction &&
                                                formik.errors.instruction
                                            }
                                        />
                                        {formik.touched.instruction &&
                                            formik.errors.instruction && (
                                                <GrubTitleText
                                                    isText={true}
                                                    mt="0.5rem"
                                                    color={
                                                        Colors.posCancleButtonRed
                                                    }
                                                    name={
                                                        formik.errors
                                                            .instruction
                                                    }
                                                />
                                            )}
                                    </Box>
                                </ChakraProvider>
                            </Box>
                        )}
                    </Box>
                </Flex>
            </DialogContent>
            <DialogActions
                sx={{
                    display: "flex",
                    justifyContent: {
                        base: "flex-end",
                        md: "center",
                    },
                    alignItems: "center",
                }}
            >
                <Flex
                    display={{
                        base: "none",
                        md: "flex",
                    }}
                    minW="18.06rem"
                    direction="column"
                />
                <Box
                    display="flex"
                    alignItems={{
                        base: "end",
                        lg: "start",
                    }}
                    justifyContent={{
                        base: "end",
                        lg: "start",
                    }}
                    flexDirection={"row"}
                >
                    <Flex
                        mt="2"
                        alignItems="center"
                        width="fit-content"
                        p={1}
                        mr={{
                            base: "0.63rem",
                        }}
                        gap="1"
                        border="0.05rem solid #E2E8F0"
                        borderRadius="1.5rem"
                        display={{
                            base: "flex",
                            md: "none",
                        }}
                    >
                        <Button
                            border="0.05rem solid #E2E8F0"
                            borderRadius="0.75rem"
                            size="xs"
                            bg={Colors.grubBackgroundColor}
                            onClick={() => handleQuantityChange("decrement")}
                            minWidth="1.5rem"
                        >
                            <Text
                                color={Colors.grubHeaderColor}
                                fontSize="0.88rem"
                            >
                                -
                            </Text>
                        </Button>
                        <GrubTitleText
                            isHeading={true}
                            color={Colors.posTextInfo}
                            name={quantity}
                        />
                        <Button
                            border="0.05rem solid #E2E8F0"
                            borderRadius="0.75rem"
                            size="xs"
                            bg={Colors.grubAddBackground}
                            onClick={() => handleQuantityChange("increment")}
                            minWidth="1.5rem"
                        >
                            <Text
                                color={Colors.grubBackgroundColor}
                                fontSize="0.88rem"
                            >
                                +
                            </Text>
                        </Button>
                    </Flex>
                    <Button
                        bg={Colors.posNavbarLink}
                        width={{
                            base: totalPrice > 100 ? "10.5rem" : "10rem",
                            lg: "25.25rem",
                        }}
                        height={{
                            base: "2rem",
                            lg: "2.38rem",
                        }}
                        mt="0.75rem"
                        onClick={() => {
                            if (
                                "total_discount" in props?.current_item[0] ===
                                true
                            ) {
                                props.editDialogOpen();
                                updateCartProduct();
                                setSelectedModifiers([]);
                                setQuantity(1);
                            } else {
                                handleAddToCart();
                            }
                        }}
                        borderRadius="1.25rem"
                        isDisabled={isLoading}
                        _disabled={{
                            bg: Colors.posNavbarLink,
                            opacity: 0.6,
                            cursor: "not-allowed",
                        }}
                    >
                        <Image
                            src={cartoutline}
                            alt={""}
                            borderRadius="full"
                            boxSize="0.94rem"
                            mr="0.31rem"
                            display={{
                                base: "none",
                                md: "flex",
                            }}
                        />
                        {undefined != props.current_item[0]?.is_update &&
                        null != props.current_item[0]?.is_update &&
                        props.current_item[0]?.is_update == true ? (
                            <GrubTitleText
                                isInstuction={true}
                                color={Colors.loginAuthBackground}
                                name={`Update to Basket ($${totalPrice})`}
                            />
                        ) : (
                            <GrubTitleText
                                isInstuction={true}
                                color={Colors.loginAuthBackground}
                                name={`Add to Basket ($${totalPrice})`}
                            />
                        )}
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            removeCurrentItem,
            orderCalculation,
            insertItem,
            updateSelectedModifiers,
            updateItemQty,
        },
        dispatch
    );
}

function mapStateToProps(state) {
    return {
        current_item: state.current_item,
        order_items: state.order_items,
        order: state.order,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GrubDialog);
